export type ErrorMessageFn = (params?: any) => string;

export const ErrorMessages = {
  required: (fieldName: string = 'This field') => `${fieldName} is required.`,
  minlength: (min: number) => `At least ${min} characters.`,
  ascii: 'Allowed: A-Z, a-z, 0-9, !@#$%^&*',
  weak: 'Password is weak.',
  email: 'Email format is invalid.',
  notMatch: 'Passwords do not match.',
  phoneNumber: 'Phone number is not valid',
  invalidUrl: 'Website format is not valid',
};
